import { render, staticRenderFns } from "./ProfitPerProduct.vue?vue&type=template&id=736fa6e2&"
import script from "./ProfitPerProduct.vue?vue&type=script&lang=js&"
export * from "./ProfitPerProduct.vue?vue&type=script&lang=js&"
import style0 from "./ProfitPerProduct.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
